import React, { useEffect, useState } from 'react';
import { api } from '../api';
import { useLocale } from '../i18n/LocaleContext';

const STATUS_KEYS = new Set(['planning', 'processing', 'deploying', 'preview_ready', 'built', 'live', 'attention_required', 'failed']);
const READY_STATUSES = new Set(['live', 'preview_ready', 'built', 'artifact_ready']);

function DeployPanel({ onNavigateToBuilder }) {
  const { t, dateLocale } = useLocale();
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.projects().then(res => setProjects(res.projects)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="deploy-panel">
      <div className="deploy-header">
        <div className="deploy-title">{t('deploy.title')}</div>
        <p className="deploy-subtitle">{t('deploy.description')}</p>
      </div>

      {loading && <p className="no-logs">{t('common.loading')}</p>}

      {!loading && projects.length === 0 && (
        <div className="deploy-empty">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" className="deploy-empty-icon"><path d="M12 2 2 7l10 5 10-5-10-5z" /><path d="m2 17 10 5 10-5" /><path d="m2 12 10 5 10-5" /></svg>
          <p>{t('deploy.empty')}</p>
          <span className="deploy-empty-hint">{t('deploy.emptyHint')}</span>
          {onNavigateToBuilder && <button type="button" className="btn" onClick={onNavigateToBuilder}>{t('deploy.goToBuilder')}</button>}
        </div>
      )}

      {!loading && projects.length > 0 && (
        <div className="deploy-list">
          {projects.map(p => {
            const statusKey = p.status || p.taskStatus;
            const statusLabel = STATUS_KEYS.has(statusKey) ? t(`projects.status.${statusKey}`) : statusKey;
            const ready = READY_STATUSES.has(statusKey);
            return (
              <div key={p.id} className="deploy-row">
                <div className="deploy-row-main">
                  <span className="deploy-row-time">{new Date(p.createdAt).toLocaleDateString(dateLocale)}</span>
                  <span className="deploy-row-name">{p.name}</span>
                  <span className="deploy-row-type">{p.type}</span>
                  {p.urls?.repository && <a className="deploy-row-link" href={p.urls.repository} target="_blank" rel="noreferrer">{t('deploy.code')}</a>}
                  {p.urls?.live && <a className="deploy-row-link" href={p.urls.live} target="_blank" rel="noreferrer">{t('deploy.liveApp')}</a>}
                  {p.urls?.deploymentDashboard && <a className="deploy-row-link" href={p.urls.deploymentDashboard} target="_blank" rel="noreferrer">{t('deploy.manage')}</a>}
                </div>
                <span className={`deploy-status-badge ${statusKey}`}>
                  {ready && <span className="deploy-status-dot" />}
                  {statusLabel}
                </span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default DeployPanel;
